import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ShButtonComponent, SHUI_MODAL_CONFIG, ShuiModalConfig, ShuiModalRef } from '@gbr-monorepo/gbr-shui';

@Component({
    selector: 'app-basic-dialog',
    imports: [ShButtonComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './basic-dialog.component.html'
})
export class BasicDialogComponent {
    protected readonly config =
        inject<ShuiModalConfig<{ message: string; reject: string; confirm: string }>>(SHUI_MODAL_CONFIG);
    protected readonly modalRef = inject<ShuiModalRef<string>>(ShuiModalRef);

    public onClose(result?: string): void {
        this.modalRef.close(result);
    }
}
